import { render, staticRenderFns } from "./HallList.vue?vue&type=template&id=3c669cd8&scoped=true"
import script from "./HallList.vue?vue&type=script&lang=js"
export * from "./HallList.vue?vue&type=script&lang=js"
import style0 from "./HallList.vue?vue&type=style&index=0&id=3c669cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c669cd8",
  null
  
)

export default component.exports